export default __webpack_public_path__ + "base-osm-500-9b09b46a2884642c7c32ba488f9e32c3.webp";